import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchIntegrationConversation } from "../../features/integration-setting/integrationSettingSlice";
import ConversationSidebar from "./ConversationSidebar";
import ConversationMessages from "./ConversationMessages";

function ConversationList() {
  const dispatch = useDispatch();
  const [selectedKey, setSelectedKey] = useState(null);

  const { conversationGroups, conversationsLoading } = useSelector(
    (state) => state.integrationSetting,
  );

  useEffect(() => {
    dispatch(fetchIntegrationConversation());
  }, [dispatch]);

  useEffect(() => {
    if (conversationGroups.length > 0 && !selectedKey) {
      setSelectedKey(conversationGroups[0].key);
    }
  }, [conversationGroups, selectedKey]);

  const selectedGroup =
    conversationGroups.find((g) => g.key === selectedKey) || null;

    return (
    <div
      className="d-flex flex-column px-3 pb-3 py-10"
      style={{ height: "calc(100vh - 56px)", overflow: "hidden" }}
    >
      <div className="d-flex flex-row border rounded-3 bg-container flex-grow-1 overflow-hidden">
        <ConversationSidebar
          groups={conversationGroups}
          selectedKey={selectedKey}
          onSelect={setSelectedKey}
        />
        <ConversationMessages
          group={selectedGroup}
          isLoading={conversationsLoading}
        />
      </div>
    </div>
  );
}

export default ConversationList;
